<template>
  <div>
    <overwatchLoader id='loader' v-if='!site'/>
    <model path="/static/ibisstyles/ibisstylesRatesHorizontalV1/" :content="model" :format='1610'></model>
    <div id='ibisStylesRatesHorizontalV1' class='d-flex flex-column justify-content-around' :style="ratesStyles" v-if='site'>
      <div id='master' class='d-flex flex-column justify-content-around'>
        <pageHead :site-name="siteName"></pageHead>
        <div id='main' class='d-flex flex-row'>
          <rates class='left' :ratesLg='ratesLg'></rates>
          <services class='right' :servicesLg='ratesLg'></services>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './header'
import Rates from './rates/rates'
import Services from './services/services'
import OverwatchLoader from '../../../../loader/overwatch'
import Change from './right/change/change'
import Hosts from './right/hosts/hosts'
import Messages from './right/messages/messages'
import model from '../../../../debug/model'

export default {
  name: 'IbisStylesRatesHorizontalV1',
  components: {
    pageHead: Header,
    rates: Rates,
    services: Services,
    change: Change,
    hosts: Hosts,
    messages: Messages,
    OverwatchLoader,
    model
  },
  data: function () {
    return {
      rightOrder: ['change', 'hosts', 'messages'],
      model: ['exemple-1.jpg'],
      rightIndex: -1,
      msgCurrentPage: 1,
      goNextComponent: true,
      lgId: 0,
      ratesStyles: {
        backgroundColor: '#BCACD5'
      }
    }
  },
  mounted () {
    this.$dm.getData(this.$route) // get data on start
    this.alternatesLg()
  },
  computed: {
    ratesLg () {
      let rates = this.site && this.site.get('rates')
      if (rates) {
        let data = rates.get('data')
        if (data) {
          return {
            lg1: data[data.languages[this.lgId].id],
            lg2: data[data.languages[1].id]
          }
        } else {
          return null
        }
      } else {
        return null
      }
    },
    messages () {
      try {
        return this.site && this.site.get('messages').get('data')
      } catch (error) {
        return null
      }
    },
    netStatus () {
      return this.$store.state.connected
    },
    site () {
      let site = this.$store.getters.site
      console.log('site()', site)
      const color = site.get('rates').get('data').colorFrame
      this.ratesStyles.backgroundColor = color
      return site
    },
    user () {
      return this.$store.getters.user
    },
    device () {
      return this.$store.getters.device
    },
    rightStatus () {
      return this.rightOrder[this.rightIndex]
    },
    siteName () {
      try {
        return this.site.get('rates').get('data').siteName
      } catch (e) {
        return ''
      }
    },
    page () {
      return this.$route.query.page
    },
    transitionName () {
      if (this.page) {
        return 'off' // no transition if page is forced
      } else {
        return 'fade'
      }
    }
  },
  watch: {
    netStatus (newStatus, oldStatus) {
      console.log('netStatus update', oldStatus, newStatus)
      // Get data on connection status change
      if (oldStatus) { // getData must not be done the first time
        console.log('netStatus getdata')
        this.$dm.getData(this.$route)
      }
    },
    user (newUser, oldUser) {
      console.log('User update', oldUser, newUser)
      // Get data when user is logged
      if (oldUser && newUser) {
        console.log('user getdata')
        this.$dm.getData(this.$route)
      }
    },
    device (newDevice, oldDevice) {
      console.log('Device update', oldDevice, newDevice)
      // refresh data on device update
      if (oldDevice && oldDevice._objCount && newDevice) {
        console.log('device getdata')
        this.$dm.getData(this.$route)
      }
    },
    site (newSite, oldSite) {
      console.log('Site updated', oldSite, newSite)
    }
  },
  methods: {
    alternatesLg () {
      let rates = this.site && this.site.get('rates')
      if (rates) {
        let data = rates.get('data')
        if (data) {
          this.lgId++
          if (this.lgId >= data.languages.length) {
            this.lgId = 0
          }
        }
      }
      setTimeout(this.alternatesLg, 7000)
    }
  }
}
</script>

<style lang='scss' scoped>
$srcWidth : 1920;
$srcHeight : 1200;
@import "../../../_ibisstyles.scss";

#ibisStylesRatesHorizontalV1 {
  width: 160vh; // https://www.alsacreations.com/article/lire/1490-comprendre-le-viewport-dans-le-web-mobile.html
  height: 100vh;
 @include paddingPercent(33, 33, 33, 33);

  #master {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: white;

    #main {
      @include heightPercent(977);

      .left {
        @include widthPercent(969);
        @include marginPercent(0, 30, 0, 44);
      }

      .right {
        @include widthPercent(737);
        @include marginPercent(0, 44, 0, 30);
      }
    }
  }
}

</style>

<style lang='scss'>
@import "../../../_ibisstyles.scss";
@import "../../../../../../scss/global.scss";

#app {
  @extend .gradientBackground;

  #ibisStylesRatesHorizontalV1 .lg1 {
    color: black;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ibisstyles/rates/horizontal/v1/ibisstylesRatesHorizontalV1.vue